/* eslint-disable no-case-declarations */
import { CONFIG_LOADING, UPDATE_CONFIG } from "../CONSTANTS";
const initialState = {
  config: {
    parameterGroups: {
      imtime: {
        parameters: {
          punchAccess: {
            defaultValue: { value: '["demoCountry"]' },
          },
          imWarehouseCountries: {
            defaultValue: { value: '["United States of America"]' },
          },
        },
      },
      imWarehouse: {
        parameters: {
          region: {
            defaultValue: {
              value:
                '{"SKP":["AMER", "EURO"],"AT":["AMER", "EURO"],"SB":["IMNA", "IME", "IMAU", "IMLA"]}',
            },
          },
        },
      },
    },
  },
  loading: true,
};

const remoteReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_CONFIG:
      return {
        ...state,
        ...action.payload,
      };
    case CONFIG_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};

export default remoteReducer;
